import { RouteRecordRaw } from "vue-router";
import HomePage from "@/modules/UsNato/pages/HomePage.vue";

const usNatoRoutes: Array<RouteRecordRaw> = [{
  path:"/usnato",
  component:HomePage
}];

export default usNatoRoutes;
